import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  Stack,
  Badge,
  Button
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { howItWorksSteps } from './marketingContent';
import MarketingFooter from './MarketingFooter';
import { marketingHeadingStyles } from './marketingStyles';

const HowItWorksPage = () => {
  return (
    <Box fontFamily="var(--telivi-font-body)" sx={marketingHeadingStyles}>
      <Box bgGradient="linear(to-b, gray.50, white)" pt={{ base: 16, lg: 24 }} pb={{ base: 12, lg: 16 }}>
        <Container maxW="container.xl">
          <Stack spacing={4} textAlign="center">
            <Text color="blue.500" fontWeight="600" textTransform="uppercase">
              How It Works
            </Text>
            <Heading as="h1" fontSize={{ base: '3xl', md: '5xl' }} fontFamily="var(--telivi-font-heading)">
              From subscription to dashboard in four steps
            </Heading>
            <Text color="gray.600" fontSize="lg">
              Pricing → Subscribe → Onboarding → Dashboard. Setup turnaround is 5-18 business days
              based on tier.
            </Text>
          </Stack>
        </Container>
      </Box>

      <Box py={{ base: 16, md: 20 }}>
        <Container maxW="container.xl">
          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6}>
            {howItWorksSteps.map((step, index) => (
              <Box
                key={step.title}
                bg="white"
                borderRadius="2xl"
                p={8}
                border="1px solid"
                borderColor="gray.100"
                boxShadow="sm"
              >
                <Badge colorScheme="blue" mb={3}>
                  Step {index + 1}
                </Badge>
                <Heading as="h2" fontSize="xl" mb={2}>
                  {step.title}
                </Heading>
                <Text color="gray.600">{step.description}</Text>
              </Box>
            ))}
          </SimpleGrid>

          <Box
            mt={12}
            bg="blue.50"
            borderRadius="2xl"
            p={{ base: 6, md: 8 }}
            textAlign="center"
          >
            <Heading as="h3" fontSize="2xl" mb={3}>
              Setup turnaround: 5-18 business days
            </Heading>
            <Text color="gray.600">
              Tier 1 provisions in 5 days, Tier 2 in 12 days, and Tier 3 in 18 days.
            </Text>
            <Button as={RouterLink} to="/pricing" mt={6} colorScheme="blue">
              View pricing tiers
            </Button>
          </Box>
        </Container>
      </Box>

      <MarketingFooter />
    </Box>
  );
};

export default HowItWorksPage;
